import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import {keyframes} from "styled-components";
import LogoTextDark from "../img/logo-text-dark.png";
import IconMain from "../img/icon-main.png";
import IconDark from "../img/icon-dark.png";
import Download from "../img/download.svg";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { BrowserRouter, Routes, Route, Link } from 'react-router';
import CourtneySherrodResume from "../documents/Courtney-Sherrod-Resume.pdf";
import { useLocation } from 'react-router';

const navOpenAnimation = keyframes`
    from {left: -100vw;}
    to {left: 0;}
`;

const navClosedAnimation = keyframes`
    from {left: 0;}
    to {left: -100vw;}
`;

const wiggleAnimation = keyframes`
    0% {transform: rotate(12deg);}
    20% {transform: rotate(-12deg);}
    40% {transform: rotate(10deg);}
    60% {transform: rotate(-8deg);}
    80% {transform: rotate(6deg);}
    100% {transform: rotate(0deg);}
`;

/* const logoAnimation = keyframes`
    0% {background-color: ${palette.pinkMain};}
    50% {background-color: ${palette.orangeMain};}
    100% {background-color: ${palette.pinkMain};}
`; */

const Nav = styled.nav`
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 16px 16px;
    visibility: hidden;
    background-color: ${palette.neutral1};
    z-index: 3;

    &.white {
        ul li a {
            color: ${palette.neutral1};
        }

        .bars-container div {
            background-color: ${palette.neutral1};
        }
    }

    a {
        text-decoration: none;

        &.active {
            font-weight: 600;

            .primary-underline::before {
                width: 100%;
            }
        }
    }

    @media (min-width: 768px) {
        height: 135px;
        padding: 0 24px;
    }

    div.nav-container {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    div.bars-container {
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        align-items: center;
        height: 18px;
        visibility: visible;

        &:hover {
            cursor: pointer;

            div {
                background-color: ${palette.orangeMain};
                transition: background-color 250ms ease;
            }
        }

        @media (min-width: 768px) {
        display: none;
        }

        div {
            width: 30px;
            height: 2px;
            border-radius: 2px;
            background-color: ${palette.neutral11};
            transition: background-color 250ms ease;
        }
    }

    div.x-container {
        height: 24px;
        width: 24px;

        &:hover {
            cursor: pointer;
        }

        @media (min-width: 768px) {
            display: none;
        }

        div.positive, div.negative {
            width: 30px;
            height: 2px;
            border-radius: 2px;
            background-color: ${palette.neutral11};
            transform: rotate(-45deg);
            position: absolute;
            top: 0;
            right: 0;
            margin-top: 12px;
            transition: background-color 250ms ease;
        }

        div.negative {
            transform: rotate(45deg);
        }

        &:hover div {
            background-color: ${palette.orangeMain};
            transition: background-color 250ms ease;
        }
    }

    ul {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-end;
        visibility: hidden;
        height: 100vh;
        width: 100vw;
        position: absolute;
        top: 0;
        right: 0;
        padding: 16px;
        z-index: 1;
        background-color: ${palette.neutral1};
        animation-name: ${navClosedAnimation};
        animation-duration: 250ms;
        list-style-type: none;
        margin-top: 0px;

        @media (min-width: 768px) {
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: center;
            width: 700px;
            height: auto;
            position: relative;
            background: none;
            visibility: visible;
            padding: 0;
            animation: none;
            margin-right: -10px;
        }

        &.open {
            visibility: visible;
            animation-name: ${navOpenAnimation};
            animation-duration: 250ms;
            position: fixed;
            left: 0;

            @media (min-width: 768px) {
                animation: none;
            }
        }

        &:not(.open) .primary-underline::before {

            @media (max-width: 767px) {
                width: 0 !important;
                display: none;
            }
        }

        div {
            margin: 4px 0;

            @media (min-width: 768px) {
                margin: 0;
            }
        }

        li {
            margin-top: 40px;
            width: 100%;
            text-align: center;

            @media (min-width: 768px) {
                margin-top: 0;
                width: auto;
            }

            a {
                color: ${palette.neutral11};
                text-decoration: none;
                font-size: 25px;
                font-weight: 400;

                &:hover {
                    color: ${palette.pinkMain};
                }

                &:focus-visible {
                    color: ${palette.pinkMain};
                    outline: 3px solid ${palette.blueMain};
                    outline-offset: 4px;
                    border-radius: 4px;
                }
    
                @media (min-width: 768px) {
                    color: ${palette.neutral11};
                    margin: 0 0 0 30px;
                    font-size: 18px;
                    padding: 10px;

                    &.resume {
                        margin-right: -10px;
                    }

                    .primary-underline::before {
                        width: 0%;
                        transition: all 200ms ease;
                    }

                    &:hover, &:focus-visible {
                        color: ${palette.neutral14};

                        .primary-underline::before {
                            width: 100%;
                        }
                    }
                }

                .primary-underline {
                    position: relative;
                    display: inline-block;
                    z-index:0;
                }
                
                .primary-underline::before {
                    transition: 300ms;
                    height: 3px;
                    content: "";
                    position: absolute;
                    bottom: -4px;
                    background-color: ${palette.pinkMain};
                    border-radius: 4px;

                    @media (max-width: 767px) {
                        bottom: -8px;
                    }
                }

                .download-button {
                    width: 16px;
                    height: 16px;
                    margin-bottom: 4px;
                }
            }
        }
    }
`;

const Logo = styled.div`
    width: 204px;
    height: auto;
    visibility: visible;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    .icon {
        height: 34px;
        width: auto;

        &.main {
            display: none;
        }
    }

    .text {
        height: 20px;
        width: auto;
        margin-top: 5px;
        margin-left: 8px;
    }

    &:hover {
        .dark {
            display: none;
        }

        .main {
            display: block;
            animation: ${wiggleAnimation} 700ms ease;
        }
    }
`;

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const [showHeader, setShowHeader] = useState(true);
    const [atTop, setAtTop] = useState(true);
    const lastScrollY = useRef(0);

    // Show header on scroll up, hide on scroll down, and track if at top
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isDesktop = window.innerWidth >= 768;
            const threshold = isDesktop ? 135 : 66;

            setAtTop(currentScrollY < 10);

            if (currentScrollY < lastScrollY.current || currentScrollY < threshold) {
                setShowHeader(true);
            } else {
                setShowHeader(false);
            }
            lastScrollY.current = currentScrollY;
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close mobile nav if resizing to desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768 && menuOpen) {
                setMenuOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [menuOpen]);

    return (
        <header style={{
            position: "fixed",
            top: showHeader ? 0 : "-150px",
            left: 0,
            width: "100%",
            zIndex: 100,
            backgroundColor: "#FFFFFF",
            transition: "top 0.3s, box-shadow 0.3s",
            boxShadow: atTop ? "none" : "0px 4px 10px 0px rgba(0, 0, 0, 0.03)"
        }}>
            <Nav>
                <div className="nav-container">
                    <a href="/">
                        <Logo>
                            <img src={IconDark} alt={"Work"} className={"icon dark"}/>
                            <img src={IconMain} alt={"Work"} className={"icon main"}/>
                            <img src={LogoTextDark} alt={"Work"} className={"text"}/>
                        </Logo>
                    </a>
                    <div className="bars-container" onClick={() => setMenuOpen(true)}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <ul className={menuOpen ? "open" : ""}>
                        <div className="x-container" onClick={() => setMenuOpen(false)}>
                            <div className="positive"></div>
                            <div className="negative"></div>
                        </div>
                        <li>
                            <a href="/" className={location.pathname === "/" ? "active" : ""}><span className={"primary-underline"}>My work</span></a>
                        </li>
                        <li>
                            <a href="/about" className={location.pathname === "/about" ? "active" : ""}><span className={"primary-underline"}>About</span></a>
                        </li>
                        <li>
                            <a href="/contact" className={location.pathname === "/contact" ? "active" : ""}><span className={"primary-underline"}>Work with me</span></a>
                        </li>
                        <li>
                            <Link to={CourtneySherrodResume} target="_blank"><span className={"primary-underline"}>Resume&nbsp;<img src={Download} alt="Resume - PDF - opens in a new tab" className={"download-button"}/></span></Link>
                        </li>
                    </ul>
                </div>
            </Nav>
        </header>
    )
}

export default Header;